import { Component, Inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import {
  MatDialogModule,
  MatDialogRef,
  MAT_DIALOG_DATA,
} from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatButtonModule } from '@angular/material/button';
import { FormsModule } from '@angular/forms';

/** What the caller can customise */
export interface NameDialogConfig {
  /** Dialog headline, e.g. “New Project”, “Rename Report” */
  title: string;
  /** Pre-populate the input (null / '' → treat as create) */
  initialName: string | null;
  /** Button label (defaults to “Save”) */
  confirmLabel?: string;
  nameError?:string|null;
}

@Component({
  selector: 'name-dialog',
  standalone: true,
  imports: [
    CommonModule,
    MatDialogModule,
    MatFormFieldModule,
    MatInputModule,
    MatButtonModule,
    FormsModule,
  ],
  templateUrl: './name-popup.component.html',
  styleUrls: ['./name-popup.component.scss'],
})
export class NameDialogComponent {
  name: string;
  title: string;
  confirmLabel: string;
  errorMessage: string | null = null;

  constructor(
    private ref: MatDialogRef<NameDialogComponent, string>,
    @Inject(MAT_DIALOG_DATA) cfg: NameDialogConfig
  ) {
    this.name = cfg.initialName ?? '';
    this.title = cfg.title;
    this.confirmLabel = cfg.confirmLabel ?? 'Save';
    this.errorMessage = cfg.nameError ?? null;
  }

  save(): void {
    this.ref.close(this.name.trim());
  }
}
